import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Loader from 'components/Loader'
import ControlledPrintersCell from 'components/ControlledPrintersCell'
import List from 'components/List'
import ListItem from 'components/List/ListItem'
import Pagination from 'components/Pagination'

import { getCurrentPaginationPage } from 'store/AppState/selector'
import { setCurrentPaginationPage } from 'store/AppState/actions'

import { MdContentCopy, MdCheck } from 'react-icons/md'

const ItemIndex = ({ devices, isLoadingDevices }) => {
  const SUBTYPE_READABLE_MAPPING = {
    'concessions-pos': 'Quick Service',
    'tabs-pos': 'Full Service',
    kiosk: 'Kiosk',
    'suites-pos': 'Suites',
    xpedite: 'Xpedite',
  }

  const history = useHistory()

  const [copyIndex, setCopyIndex] = useState(null)

  const headers = ['Name', 'Serial', 'Model', 'Receipt Printer', 'Controlled Printers']

  const currentPaginationPage = useSelector((state) =>
    getCurrentPaginationPage(state, 'configurations'),
  )
  const handlePersistPaginationPage = (page) => {
    setCurrentPaginationPage({ screen: 'configurations', page })
  }

  const copyId = (e, deviceId, index) => {
    e.stopPropagation()
    setCopyIndex(index)
    navigator.clipboard.writeText(deviceId)
    setTimeout(() => setCopyIndex(null), 1500)
  }

  if (isLoadingDevices) {
    return <Loader />
  }

  return (
    <div className="devices-list">
      <List headerItems={headers}>
        {devices?.result?.map(
          ({ uuid, name, deviceId, deviceSubtype, printerName, controlledPrinters }, index) => (
            <div className="item" key={uuid}>
              <div
                className="row"
                onClick={() => {
                  history.push(`configurations/${uuid}/edit`)
                }}
              >
                <div className="item-info-wrapper">
                  <span className="name">
                    <ListItem content={name} />
                  </span>
                </div>
                <div className="item-info-wrapper">
                  <span className="copy-button" onClick={(e) => copyId(e, deviceId, index)}>
                    {copyIndex === index ? <MdCheck /> : <MdContentCopy />}
                  </span>
                  <ListItem content={deviceId} />
                </div>
                <div className="item-info-wrapper">
                  <ListItem content={SUBTYPE_READABLE_MAPPING[deviceSubtype]} />
                </div>
                <div className="item-info-wrapper">
                  <ListItem content={printerName} />
                </div>
                <div className="item-info-wrapper">
                  <ListItem content={<ControlledPrintersCell printers={controlledPrinters} />} />
                </div>
              </div>
            </div>
          ),
        )}
      </List>
      <section className="footer-pagination">
        <Pagination
          currentPersistedPaginationPage={currentPaginationPage}
          handlePersistPaginationPage={handlePersistPaginationPage}
          paginator={devices}
        />
      </section>
    </div>
  )
}

ItemIndex.defaultProps = {
  emptyStateTitle: 'No items found!',
  emptySearchResultMessage: 'There are no items matching given search query.',
  emptySearchResultTitle: "We couldn't find what you were looking for",
  isFilteringItems: false,
}

ItemIndex.propTypes = {
  devices: PropTypes.object.isRequired,
  isLoadingDevices: PropTypes.bool.isRequired,
  devicesDetailsLocationState: PropTypes.shape({
    isReadOnly: PropTypes.bool,
    backTo: PropTypes.string,
  }),
}

export default ItemIndex
